module.exports = __webpack_public_path__ + "media/images/icons/world-0cc84b26712107bb58581677b4901482.svg";